<template>
  <div
    class="label-search-field"
    :class="[
      { 'label-search-field--flex': flex },
      customClass,
    ]"
  >
    <span :id="labelId" class="label-search-field__label">{{ label }}</span>
    <div class="label-search-field__control">
      <i class="bi bi-search label-search-field__icon" aria-hidden="true"></i>
      <input
        :id="inputId"
        :value="modelValue"
        class="label-search-field__input"
        type="text"
        :placeholder="placeholder"
        :disabled="disabled"
        :aria-labelledby="labelId"
        autocomplete="off"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelSearchField',
  props: {
    label: {
      type: String,
      default: 'Search',
    },
    inputId: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    flex: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['update:modelValue', 'input'],
  computed: {
    labelId() {
      return `${this.inputId}-label`;
    },
  },
  methods: {
    onInput(event) {
      const value = event.target.value;
      this.$emit('update:modelValue', value);
      this.$emit('input', value);
    },
  },
};
</script>

<style src="../styles/LabelSearchField.css"></style>
